/**
 * @author Madhuri < sai.madhuri@314ecorp.com >
 * @description React Hook for admin to verify a session
 */
import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from 'utils/appEvents';
import { invalidateMetadata } from 'app-constants/queryKeys';

/**
 * Manual verification of a session
 *
 */
const useUpdateIdentityVerificationStatus = (): UseMutationResult<void, IAxiosError, { providerId: string }, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ providerId }) => {
			const { data } = await api.EKYCServiceApi.patchIdentityVerificationStatus(providerId);
			return data;
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateIdentityVerificationStatus;
